import {
  getQuizById,
  getQuizRelatedById,
  getQuizResultById,
} from "@/services/quizService";
import { QUIZ_QUERY_KEYS } from "@/types";
import { useQuery } from "@tanstack/react-query";

export const useQuizDetail = (id: number | null) => {
  return useQuery({
    queryKey: [QUIZ_QUERY_KEYS.DETAIL, id],
    queryFn: () => getQuizById(id!),
    enabled: !!id,
  });
};

export const useQuizResult = (id?: number) => {
  return useQuery({
    queryKey: [QUIZ_QUERY_KEYS.DONE_DETAIL, id],
    queryFn: () => getQuizResultById(id!),
    enabled: !!id,
  });
};

export const useQuizRelated = (id?: number) => {
  return useQuery({
    queryKey: [QUIZ_QUERY_KEYS.RELATED_QUIZ_LIST, id],
    queryFn: () => getQuizRelatedById(id!),
    enabled: !!id,
  });
};
